<div class="preview-container" *ngIf="optimizedImageUrl">
	<div class="preview-wrapper">
		<img [src]="optimizedImageUrl" alt="Focal area preview">
	</div>
	<div class="preview-info">
		<span class="preview-dimensions">{{ previewWidth }}px × {{ previewHeight }}px</span>
		<span class="preview-aspect-ratio">{{ displayAspectRatio }}</span>
	</div>
</div>

<div class="no-preview" *ngIf="!optimizedImageUrl">
	<mat-icon>crop</mat-icon>
	<p>Select a focal area to preview</p>
</div>
